import React from 'react';
import PropTypes from 'prop-types';
import {  CreditCardPayment, NetNinetyPayment } from './PaymentInformation';
import PaymentDisplay from './PaymentDisplay';
import Button from '../../components/Button';
import PaymentApi from '../../payments';
import Api from '../../Api';

import BackIcon from '../../images/icons/back-button.svg';

export default class PaymentEditingModal extends React.Component {
  static propTypes = {
    instrumentList: PropTypes.array.isRequired,
    setSelectedInstrument: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.instrumentList = this.instrumentList.bind(this);
    this.addBilling = this.addBilling.bind(this);
    this.actionLinkBankAccount = this.actionLinkBankAccount.bind(this);
    this.actionLinkCreditCard = this.actionLinkCreditCard.bind(this);

    this.state = {
      addingPayment: false
    };
  }

  addBilling() {
    return (
      <div>
        <div className="back-button link" onClick={() => this.setState({ addingPayment: false })}><img role="presentation" src={BackIcon} /></div>
        <div className="row payment-options">
          <CreditCardPayment title="ADD CREDIT CARD" buttonText="LINK CARD" onClick={this.actionLinkCreditCard} />
          <NetNinetyPayment title="ADD BANK ACCOUNT" buttonText="LINK ACCOUNT" onClick={this.actionLinkBankAccount} />
        </div>
        <div className="button-box">
          <p className="note">
            By linking a payment instrument, you authorize Indigo Fair. I authorize to  electronically debit your account
            and, if necessary, electronically credit account  to correct erroneous debits.
          </p>
        </div>
      </div>
    );
  }

  instrumentList() {
    let instruments = this.props.instrumentList.map(instrument =>
      <div className="instrument-display-entry" key={`payment-${instrument.token}`}>
        <PaymentDisplay payment={instrument} />
        <div className="use-this-instrument link" onClick={() => this.props.setSelectedInstrument(instrument.token)}>
          Use This {instrument.card ? 'Credit Card' : 'Bank Account'}
        </div>
      </div>
    );

    return (
      <div>
        <div className="instrument-listing">{instruments}</div>
        <div className="button-box">
          <Button className="full-width" onClick={() => this.setState({ addingPayment: true })}>Add New Payment</Button>
        </div>
      </div>
    );
  }

  actionLinkBankAccount(event) {
    event.preventDefault();
    let user = Api.cache.getUser();
    let returnValue = PaymentApi.addBankAccount(user);

    returnValue.then(
      response => {
        this.props.setSelectedInstrument(response.token);
        return response;
      }
    );

    return returnValue;
  }

  actionLinkCreditCard(event) {
    event.preventDefault();
    let user = Api.cache.getUser();
    let returnValue = PaymentApi.addCreditCard(user);

    returnValue.then(
      response => {
        this.props.setSelectedInstrument(response.token);
        return response;
      }
    );

    return returnValue;
  }

  render() {
    return (
      <div className="payment-editing-component">
        <h2>Edit Billing Information</h2>
        {this.state.addingPayment ? this.addBilling() : this.instrumentList()}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/checkout/PaymentEditingModal.js
 **/